/**
 * Safari / iOS 10+ 运行时补丁（与 @vitejs/plugin-legacy 互补）
 */
import { defineNuxtPlugin } from '#app'
import 'core-js/es/global-this'
import 'core-js/es/symbol'
import 'core-js/es/array/from'
import 'core-js/es/array/at'
import 'core-js/es/array/includes'
import 'core-js/es/array/find'
import 'core-js/es/array/find-index'
import 'core-js/es/array/flat'
import 'core-js/es/array/flat-map'
import 'core-js/es/object/assign'
import 'core-js/es/object/entries'
import 'core-js/es/object/values'
import 'core-js/es/object/from-entries'
import 'core-js/es/object/has-own'
import 'core-js/es/string/includes'
import 'core-js/es/string/starts-with'
import 'core-js/es/string/ends-with'
import 'core-js/es/string/pad-start'
import 'core-js/es/string/pad-end'
import 'core-js/es/string/replace-all'
import 'core-js/es/promise'
import 'core-js/es/promise/finally'
import 'core-js/es/map'
import 'core-js/es/set'
import 'core-js/web/dom-collections'
import 'core-js/web/queue-microtask'

export default defineNuxtPlugin(() => {
  try {
    // polyfill 在模块加载阶段已注入
  } catch (e) {
    console.warn('[polyfills] plugin failed safe:', e)
  }
})
